// extracted by mini-css-extract-plugin
export default {"reactSelectContainer":"customers_reactSelectContainer__L79+g","table_wraper":"customers_table_wraper__cZM1B"};